import React from "react";
import { Link } from "react-router-dom";
import { Card, Button } from "react-bootstrap";
import { CheckCircle } from "@material-ui/icons";
import { cryptoTokenDecode } from "./../Common/Common";
import Logo from "../../assets/img/logo.png";
import * as message from "./../../config/CommonMessages";

class ThankYou extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  checkLoggedIn() {
    var userType = cryptoTokenDecode().usertype;
    if (userType !== null && userType.toUpperCase() === message.ADMIN) {
      this.props.history.push("/RegistrationRequests");
    } else {
      this.props.history.push("/artwork");
    }
  }

  render() {
    let token = localStorage.getItem("token");
    if (localStorage.getItem("accessToken")) {
      this.checkLoggedIn();
    }
    return (
      <div className="thank-you-msg-container">
        <div className="thank-you-msg">
          <img
            src={Logo}
            alt="logo"
            style={{ width: "500px", marginTop: "70px" }}
          />
          <Card style={{ marginTop: "90px" }}>
            <span>
              <CheckCircle />
            </span>
            <div>
              {token == null
                ? "Thanks for signing up! Our team will review your application and notify you once your account is approved."
                : "Thanks for signing up! Please login to continue."}
            </div>
            <Link to={"/login"}>
              <Button
                variant="primary"
                className="btn-blue btn-medium"
                style={{ marginTop: "10px" }}
              >
                Return to Login
              </Button>
            </Link>
          </Card>
        </div>
      </div>
    );
  }
}

export default ThankYou;
